export default __webpack_public_path__ + "static/media/logo.d128de9c.png";